/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Space_Profile_Map_PendingInputs */

const en_admin_space_profile_map_pending = /** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an address to see the map`)
};

const de_admin_space_profile_map_pending = /** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse hinzufügen, um die Karte zu sehen`)
};

const es_admin_space_profile_map_pending = /** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade una dirección para ver el mapa`)
};

const fr_admin_space_profile_map_pending = /** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez une adresse pour voir la carte`)
};

/** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */
const it_admin_space_profile_map_pending = en_admin_space_profile_map_pending;

/** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */
const pt_br2_admin_space_profile_map_pending = en_admin_space_profile_map_pending;

/** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */
const pl_admin_space_profile_map_pending = en_admin_space_profile_map_pending;

/** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */
const hu_admin_space_profile_map_pending = en_admin_space_profile_map_pending;

/** @type {(inputs: Admin_Space_Profile_Map_PendingInputs) => LocalizedString} */
const ro_admin_space_profile_map_pending = en_admin_space_profile_map_pending;

/**
* | output |
* | --- |
* | "Add an address to see the map" |
*
* @param {Admin_Space_Profile_Map_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_space_profile_map_pending = /** @type {((inputs?: Admin_Space_Profile_Map_PendingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Space_Profile_Map_PendingInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_space_profile_map_pending(inputs)
	if (locale === "de") return de_admin_space_profile_map_pending(inputs)
	if (locale === "es") return es_admin_space_profile_map_pending(inputs)
	if (locale === "fr") return fr_admin_space_profile_map_pending(inputs)
	if (locale === "it") return it_admin_space_profile_map_pending(inputs)
	if (locale === "pt-BR") return pt_br2_admin_space_profile_map_pending(inputs)
	if (locale === "pl") return pl_admin_space_profile_map_pending(inputs)
	if (locale === "hu") return hu_admin_space_profile_map_pending(inputs)
	return ro_admin_space_profile_map_pending(inputs)
});
export { admin_space_profile_map_pending as "admin.space_profile_map.pending" }